import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2359.js";
function n({ size: e = l }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ i("rect", { shapeRendering: "optimizeQuality", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ i(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M41 28C41 35.1797 35.1797 41 28 41C20.8203 41 15 35.1797 15 28C15 20.8203 20.8203 15 28 15C35.1797 15 41 20.8203 41 28Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M32.8403 25.6255C33.1244 25.3456 33.1277 24.8883 32.8478 24.6042C32.5678 24.3201 32.1105 24.3167 31.8264 24.5967L26.47 29.875L24.1735 27.6127C23.8894 27.3327 23.4321 27.3362 23.1522 27.6203C22.8722 27.9045 22.8757 28.3617 23.1598 28.6417L26.4702 31.9028L32.8403 25.6255Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M41 28C41 35.1797 35.1797 41 28 41C20.8203 41 15 35.1797 15 28C15 20.8203 20.8203 15 28 15C35.1797 15 41 20.8203 41 28ZM39.5556 28C39.5556 34.382 34.382 39.5556 28 39.5556C21.618 39.5556 16.4444 34.382 16.4444 28C16.4444 21.618 21.618 16.4444 28 16.4444C34.382 16.4444 39.5556 21.618 39.5556 28Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
n.__tags = [];
export {
  n as MetricApproveIcon
};
//# sourceMappingURL=index.es380.js.map
